import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Text,
} from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';
import FormLabel from '~/components/FormLabel/FormLabel';
import { TagSelect } from '~/components/TagSelect';

import { TagSuggestion } from '../components';
import {
  MAX_CHARACTERS,
  TAG_PREFIX,
  TAG_SUGGESTIONS,
} from './ThemesAndAffinities.constants';
import { ThemesAndAffinitiesValues } from './ThemesAndAffinities.types';

export const ThemesAndAffinities = React.forwardRef<
  HTMLFormElement,
  FormikProps<ThemesAndAffinitiesValues>
>(({ errors, handleSubmit, setValues, values }, ref) => {
  const suggestedTags = TAG_SUGGESTIONS.filter(
    (tag) => !values.themesAndAffinities?.includes(tag),
  );
  return (
    <>
      <Form onSubmit={handleSubmit} ref={ref}>
        <FormControl
          id="themeAndAffinities"
          isInvalid={!!errors.themesAndAffinities}
          marginBottom={6}
        >
          <Box marginBottom={3}>
            <FormLabel display="inline" fontWeight={400} fontSize="md">
              Add 3-5 tags that best suit your profile:
            </FormLabel>

            <Text display="inline" color="primary.300" fontSize="sm">
              (Max. 15 characters each)
            </Text>
          </Box>

          <TagSelect
            maxCharacters={MAX_CHARACTERS}
            onChange={(tags) => setValues({ themesAndAffinities: tags })}
            prefix={TAG_PREFIX}
            tags={values.themesAndAffinities ?? []}
            tagProps={{
              _active: { borderColor: 'primary.500' },
              _hover: { borderColor: 'primary.600' },
            }}
          >
            {({ handleAdd, renderUI }) => (
              <>
                <Box marginBottom={4}>
                  {renderUI()}

                  <FormErrorMessage data-testid="error-tags">
                    {errors.themesAndAffinities}
                  </FormErrorMessage>
                </Box>

                {!!suggestedTags.length && (
                  <>
                    <Text color="primary.300" fontSize="xs">
                      Or add from these:
                    </Text>

                    <Flex flexWrap="wrap" marginX={-1}>
                      {suggestedTags.map((tag) => (
                        <TagSuggestion
                          key={`suggestion-${tag}`}
                          data-testid={`suggestion-${tag}`}
                          onClick={() => handleAdd(tag)}
                        >
                          {tag}
                        </TagSuggestion>
                      ))}
                    </Flex>
                  </>
                )}
              </>
            )}
          </TagSelect>
        </FormControl>
      </Form>
    </>
  );
});
